var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.181H5.275V3.52c0-.623.445-.769.758-.769h1.922V.009L5.307 0C2.37 0 1.701 2.045 1.701 3.353v1.828H0v2.824h1.7V16h3.575V8.005h2.412L8 5.181z",
    fill: "#2C3032"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgOCAxNiI+CiAgIDxwYXRoIGQ9Ik04IDUuMTgxSDUuMjc1VjMuNTJjMC0uNjIzLjQ0NS0uNzY5Ljc1OC0uNzY5aDEuOTIyVi4wMDlMNS4zMDcgMEMyLjM3IDAgMS43MDEgMi4wNDUgMS43MDEgMy4zNTN2MS44MjhIMHYyLjgyNGgxLjdWMTZoMy41NzVWOC4wMDVoMi40MTJMOCA1LjE4MXoiIGZpbGw9IiMyQzMwMzIiIGZpbGwtcnVsZT0ibm9uemVybyIgLz4KPC9zdmc+";
export { SvgIconFacebook as ReactComponent };